import { useEffect } from 'react';
import { Platform } from 'react-native';

import { useCurrentOrganization } from '@/core/organization';

// Appends the white-label organization's SEO keywords as a <meta name="keywords">
// tag. Intentionally minimal for now — keywords live on the organization as a
// comma-separated value (or array on the public endpoint). Web only.
export function useOrganizationKeywords() {
  const { organization } = useCurrentOrganization();

  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const keywords = Array.isArray(organization?.keywords)
      ? organization?.keywords.join(', ')
      : organization?.keywords;

    if (!keywords) return;

    let meta = document.querySelector<HTMLMetaElement>("meta[name='keywords']");

    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'keywords';
      document.head.appendChild(meta);
    }

    meta.content = keywords;
  }, [organization]);
}
